import { IMenuItem } from "./provider/IMenuItem";
import { vsName as menuServiceName, MenuService } from "./provider/MenuService";

import { StateService } from "@uirouter/angularjs/lib-esm";

export class MenuController {
  static $inject: string[] = ["$state", menuServiceName];
  readonly $state: StateService;
  readonly menuService: MenuService;

  readonly pageSize: number = 5;
  private pageIndex: number = 0;

  showMore: boolean = false;

  constructor($state: StateService, menuService: MenuService) {
    this.$state = $state;
    this.menuService = menuService;
  }

  getMenuItems(): IMenuItem[] {
    const all = this.menuService.getMenuItems();
    const activeMenuItem = all.find((mi) => this.selfOrChildIsActive(mi));
    const debug = all.map((mi) => ({
      display: mi.getDisplay(),
      active: this.selfOrChildIsActive(mi),
    }));
    const activeMenuItemIndex = activeMenuItem
      ? all.indexOf(activeMenuItem)
      : -1;

    const skip = this.pageIndex * this.pageSize;
    let pagedItems = all.slice(skip, skip + this.pageSize);

    if (activeMenuItem && !pagedItems.includes(activeMenuItem)) {
      if (activeMenuItemIndex <= skip) {
        pagedItems = [activeMenuItem, ...pagedItems];
      } else {
        pagedItems = [...pagedItems, activeMenuItem];
      }
    }

    return pagedItems;
  }

  hasNextItems() {
    return (
      (this.pageIndex + 1) * this.pageSize <
      this.menuService.getMenuItems().length
    );
  }

  hasPreviousItems() {
    return this.pageIndex > 0;
  }

  nextPage() {
    if (this.hasNextItems()) {
      this.pageIndex += 1;
    }
  }
  previousPage() {
    if (this.hasPreviousItems()) {
      this.pageIndex -= 1;
    }
  }

  isActive(menuItem: IMenuItem): boolean {
    return (
      this.stateMatches(menuItem) &&
      menuItem.getChildren().find((c) => this.isActive(c)) === undefined
    );
  }

  selfOrChildIsActive(menuItem: IMenuItem): boolean {
    const match = this.findMenuItemMatchingState(menuItem);
    return match !== undefined;
  }

  stateIncludes(state: string): boolean {
    return this.$state.includes(state);
  }

  private findMenuItemMatchingState(
    menuItem: IMenuItem
  ): IMenuItem | undefined {
    if (this.stateMatches(menuItem)) {
      return menuItem;
    }

    return menuItem
      .getChildren()
      .find((c) => this.findMenuItemMatchingState(c));
  }

  private stateMatches(menuItem: IMenuItem): boolean {
    const state = menuItem.getState();
    const activeOnState = menuItem.getActiveOnState();
    const excludeActiveOnState = menuItem.getExcludeActiveOnState();

    const match =
      this.$state.includes(state) || this.$state.includes(activeOnState);
    if (!match) {
      return false;
    }

    return !(
      excludeActiveOnState && this.$state.includes(excludeActiveOnState)
    );
  }
}
